import React from "react";
import { Route } from "react-router-dom";
import About from "../components/index";

const AboutRoutes = () => {
  return (
    <>
      <Route path="/about" element={<About />} /> 
    </>
  );
};

export default AboutRoutes;
